export default __webpack_public_path__ + "images/0xd90764041da2720396863836e9f78ddaee140533.png";